import { useMutation, UseMutationOptions } from 'react-query';
import { AxiosError } from "axios";

import request from "common/request";

type UpdateUserDataMutationVariable = {
  name           : string;
  mobile         : string;
  postalNumber   : string;
  defaultAddress : string;
  detailAddress  : string;
};

export const usePutUserData = ( 
  options?: UseMutationOptions<any, AxiosError,UpdateUserDataMutationVariable>
) => { 
  return useMutation<any, AxiosError, UpdateUserDataMutationVariable>(
    async (infoData) => {
      try {
        const response = await request.post('/mypage/update/user', {
          name: infoData.name,
          mobile: infoData.mobile,
          postalNumber   : infoData.postalNumber,
          defaultAddress : infoData.defaultAddress,
          detailAddress  : infoData.detailAddress
        }
        );
        return response
      } catch(e){
        //@ts-ignore
        const result = e.response;
        return result
      }
    },
    {
      ...options
    }
  )
};

export default usePutUserData;